export const mapBoundsLiteral = bounds => ({
    north: bounds.top_left.lat,
    west: bounds.top_left.lon,
    south: bounds.bottom_right.lat,
    east: bounds.bottom_right.lon,
})

// Stable coordinates prevent repeated idle events from issuing the same search.
export const mapBoundsFilter = (bounds, zoom) => [
    Math.ceil(bounds.north * 1e6) / 1e6,
    Math.ceil(bounds.east * 1e6) / 1e6,
    Math.floor(bounds.south * 1e6) / 1e6,
    Math.floor(bounds.west * 1e6) / 1e6,
    zoom,
].join(',')

export const parseMapBounds = value => {
    if(!value) return null
    const parts = value.split(',')
    const [north, east, south, west, zoom] = parts.map(Number)
    if(parts.length < 4 || parts.slice(0, 4).some(part => !part.trim()) ||
        ![north, east, south, west].every(Number.isFinite) ||
        Math.abs(north) > 90 || Math.abs(south) > 90 ||
        Math.abs(east) > 180 || Math.abs(west) > 180 || north < south) return null
    return {bounds: {north, east, south, west}, zoom: Number.isFinite(zoom) ? Math.min(22, Math.max(0, zoom)) : undefined}
}
